// extracted by mini-css-extract-plugin
export default {"main-container":"app_main-container__OJCCC"};